export default __webpack_public_path__ + "static/media/explore.c22f1c6e.jpg";